import request from '@/router/axios'
/**
 * 获取本地最新appBuildInfo
 * @param {query}
 */

export const htmlAppBuildInfo = (query) => {
  return request({
    url: `/js/appBuildInfo.json?t=${new Date().getTime()}`,
    method: 'get',
    params: query
  })
}